/* eslint-disable no-unused-vars */
/*
 * @Description: 
 * @Author: guojun
 * @Date: 2020年10月23日14:35:17
 * @LastEditTime: 2020年10月23日14:35:23
 * @LastEditors: guojun
 */
import request from '../utils/request'
import utils from '@/utils/utils';
class Solution {
	//获取API文档菜单列表
	getSolution(self) {
		return new Promise((resolve, reject) => {
			request.post(self, {
                // action: "apidoc.getapidocmenus",
                action:"",
				url:'/solution',
				data: {}
			}).then(res => {
				if (res.code == 20000) {
					resolve({
						success: true,
						data: res.data
					})
				} else {
					self.$message.error(res.message)
				}
			})
		})
	}
}
export default new Solution()